module.exports = __webpack_public_path__ + "images/index/img09.0b26dd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/meichiao/img09.jpg
// module id = OcGa
// module chunks = 21